/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleMessages } from '../../_helpers/utilities'
import {
  IPerformanceFilter,
  ISuperAdminDashboardState,
} from '../../_models/superAdmin/dashboardInterface'
import * as superAdminService from '../../_services/superAdmin'
import { RootState } from '../../_store/store'
import { stopLoader } from '../loaderSlice'
import { errorToast } from '../toastSlice'
const initialState: ISuperAdminDashboardState = {
  limit: 0,
  totalBookings: 0,
  totalCustomers: 0,
  totalBusinesses: 0,
  bookingsThisMonth: 0,
  customersThisMonth: 0,
  businessesThisMonth: 0,
  businessPerformanceList: {
    current_page: 1,
    data: [],
    total: 20,
    per_page: 10,
    last_page: 0,
  },

  superAdminStatistics: {
    todays_bookings_count: {
      total_bookings_count: 0,
      completed_bookings_count: 0,
      upcoming_bookings_count: 0,
      cancelled_bookings_count: 0,
      expired_bookings_count: 0,
      scanned_bookings_count: 0,
      pending_bookings_count: 0,
      blocked_bookings_count: 0,
    },
    check_in_status: {
      today: {
        total_bookings: 0,
        todays_completed_bookings_count: 0,
      },
      this_month: {
        total_bookings: 0,
        completed_bookings_count: 0,
      },
      this_week: {
        total_bookings: 0,
        completed_bookings_count: 0,
      },
    },
    customer_visits: {
      this_month: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      },
      this_week: {
        Sun: 0,
        Mon: 0,
        Tue: 0,
        Wed: 0,
        Thu: 0,
        Fri: 0,
        Sat: 0,
      },
    },
  },
  businessList: {
    current_page: 0,
    data: [],
    total: 0,
    per_page: 0,
    last_page: 0,
  },
  filters: {
    page: 0,
    per_page: 0,
    search: '',
    is_favourite: false,
  },
  performanceListFilters: {
    search: '',
    page: 1,
    per_page: 10,
  },
  dashboardBusinessList: [],
  isLoadingBusinessList: false,
  businessDrawer: false,
  isLoadingBusinessPerformance: false,
}
export const getSuperAdminDashboard = createAsyncThunk(
  '/getSuperAdminDashboard',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await superAdminService.getSuperAdminDashboard()
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getSuperAdminPerformance = createAsyncThunk(
  '/getSuperAdminPerformance',
  async (performanceFilters: IPerformanceFilter, { dispatch, rejectWithValue }) => {
    try {
      const response = await superAdminService.getSuperAdminPerformance(performanceFilters)
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)

export const getSuperAdminDashboardBusiness = createAsyncThunk(
  '/getSuperAdminDashboardBusiness',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await superAdminService.getSuperAdminDashboardBusiness()
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const getSuperAdminStatistics = createAsyncThunk(
  '/getSuperAdminStatistics',
  async (id: { business_id: string }, { dispatch, rejectWithValue }) => {
    try {
      const response = await superAdminService.getSuperAdminStatistics(id)
      return response
    } catch (err: any) {
      dispatch(stopLoader())
      dispatch(errorToast(handleMessages(err.message)))
      return rejectWithValue(err)
    }
  },
)
export const superAdminSlice = createSlice({
  name: 'superAdmin',
  initialState,
  reducers: {
    changePerformanceListFilters: (state, action) => {
      state.performanceListFilters = action.payload
    },
    resetPerformanceListFilters: (state) => {
      state.performanceListFilters = initialState.performanceListFilters
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSuperAdminDashboard.fulfilled, (state, action) => {
      state.totalBookings = action.payload.data.booking_stats.total
      state.totalCustomers = action.payload.data.customer_stats.total
      state.totalBusinesses = action.payload.data.business_stats.total
      state.bookingsThisMonth = action.payload.data.booking_stats.this_month
      state.customersThisMonth = action.payload.data.customer_stats.this_month
      state.businessesThisMonth = action.payload.data.business_stats.this_month
    })
    builder.addCase(getSuperAdminPerformance.pending, (state) => {
      state.isLoadingBusinessPerformance = true
    })
    builder.addCase(getSuperAdminPerformance.fulfilled, (state, action) => {
      state.businessPerformanceList = action.payload.data
      state.isLoadingBusinessPerformance = false
    })
    builder.addCase(getSuperAdminPerformance.rejected, (state) => {
      state.isLoadingBusinessPerformance = false
    })
    builder.addCase(getSuperAdminDashboardBusiness.fulfilled, (state, action) => {
      state.dashboardBusinessList = action.payload.data.data
    })
    builder.addCase(getSuperAdminStatistics.fulfilled, (state, action) => {
      state.superAdminStatistics = action.payload.data
    })
  },
})
export const { changePerformanceListFilters, resetPerformanceListFilters } = superAdminSlice.actions
export const superAdminDashboardState = (state: RootState) => state.superAdminDashboard
const superAdminDashboardReducer = superAdminSlice.reducer
export default superAdminDashboardReducer
